export interface ModalDeleteProfileData {
    id: number;
    title: string;
}
